"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var DatePickerBody_1 = require("./DatePickerBody");
var DatePickerWidgetStyles_1 = require("../../styles/DatePickerWidgetStyles");
var DatePickerDayOfWeekHeader_1 = require("./DatePickerDayOfWeekHeader");
var Date_1 = require("../../utils/Date");
var Localize_1 = require("../../../gen-src/Localize");
var CarouselWidget_1 = require("./CarouselWidget");
var DomUtil_1 = require("../../utils/DomUtil");
var DatePickerWidget = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerWidget, _super);
    function DatePickerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.headerId = DomUtil_1.generateId();
        _this.handleOnConfirm = function (date) {
            if (_this.props.onConfirm) {
                _this.props.onConfirm(date);
            }
        };
        _this.handleOnChange = function (date) {
            if (_this.props.onChange && date.getTime() !== _this.props.selectedDate.getTime()) {
                _this.props.onChange(date);
            }
        };
        _this.handleFocusedDateChange = function (date) {
            if (date !== _this.state.focusedDate) {
                _this.setState({ focusedDate: date });
            }
        };
        _this.handleClickPrevMonth = function () {
            _this.handleFocusedDateChange(Date_1.getDateWithMonthOffset(_this.state.focusedDate, -1));
        };
        _this.handleClickNextMonth = function () {
            _this.handleFocusedDateChange(Date_1.getDateWithMonthOffset(_this.state.focusedDate, 1));
        };
        _this.isDateDisabled = function (date) {
            return _this.props.isDateDisabled && _this.props.isDateDisabled(date);
        };
        _this.state = {
            focusedDate: _this.props.selectedDate,
        };
        return _this;
    }
    DatePickerWidget.prototype.componentDidMount = function () {
        if (this.props.autofocus) {
            var tabbables = ReactDOM.findDOMNode(this).querySelectorAll('[tabindex="0"]');
            if (tabbables.length > 0) {
                DomUtil_1.timeoutFocus(tabbables[tabbables.length - 1]);
            }
        }
    };
    DatePickerWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.setState({ focusedDate: this.props.selectedDate });
        }
    };
    DatePickerWidget.prototype.getDisplayedMonthAndYear = function () {
        return Localize_1.Formatters.formatFullMonthAndFullYear(this.state.focusedDate);
    };
    DatePickerWidget.prototype.render = function () {
        var displayedMonthAndYear = this.getDisplayedMonthAndYear();
        var headerProps = {
            id: this.headerId,
            nextButtonTitle: Localize_1.Messages.nextMonth(),
            onNextClick: this.handleClickNextMonth,
            onPreviousClick: this.handleClickPrevMonth,
            prevButtonTitle: Localize_1.Messages.previousMonth(),
            role: 'heading',
            style: DatePickerWidgetStyles_1.datePickerHeaderStyle,
        };
        var bodyProps = {
            focusedDate: this.state.focusedDate,
            isDateDisabled: this.isDateDisabled,
            onChange: this.handleOnChange,
            onConfirm: this.handleOnConfirm,
            onFocusedDateChange: this.handleFocusedDateChange,
            selectedDate: this.props.selectedDate,
            showWeekNumbers: this.props.showWeekNumbers,
        };
        return (React.createElement("div", { style: DatePickerWidgetStyles_1.datePickerWidgetStyle, "data-tb-test-id": this.props.testId },
            React.createElement(CarouselWidget_1.CarouselWidget, tslib_1.__assign({}, headerProps), displayedMonthAndYear),
            React.createElement("div", { "aria-labelledby": this.headerId, role: 'grid', "aria-rowcount": -1 },
                React.createElement(DatePickerDayOfWeekHeader_1.DatePickerDayOfWeekHeader, { showWeekNumbers: this.props.showWeekNumbers }),
                React.createElement(DatePickerBody_1.DatePickerBody, tslib_1.__assign({}, bodyProps)))));
    };
    DatePickerWidget.defaultProps = {
        selectedDate: new Date(),
    };
    return DatePickerWidget;
}(React.Component));
exports.DatePickerWidget = DatePickerWidget;
//# sourceMappingURL=DatePickerWidget.js.map